











































import Vue from "vue";
import VariableInput from "@/components/util/VariableInput.vue";
import FooterSimple from "@/parts/common/FooterSimple.vue";
import { passwordResetting, validatePasswordResetting } from "@/api/Login";
import { passwordConstraintMessage, passwordConstraintErrorMessage, passwordRegExp } from "./constraint";
import axios from "axios";
import { ErrorResponse } from "@/api/dto/Error";

export default Vue.extend({
  name: "PasswordResetting",
  components: {
    VariableInput,
    FooterSimple,
  },
  watch: {
    "accountData.newPassword"(password: string) {
      this.inputs["newPassword"].error = passwordRegExp.test(password) ? "" : passwordConstraintErrorMessage;
    },
  },
  data() {
    return {
      accountData: {
        newPassword: "",
      },
      inputs: {
        newPassword: {
          name: "新しいパスワード",
          type: "password",
          constraint: passwordConstraintMessage,
          placeholder: "新しいパスワード",
          error: "",
        },
      },
      submitModal: false,
      validate: {
        isValidate: false,
        message: "",
      }
    };
  },
  async beforeRouteEnter(to, from, next) {
    try {
      var res = await validatePasswordResetting(to.params.id);
      next(vm => (vm.$data).validate = res);
    } catch (e) {
      next(vm => (vm.$data).validate.message = "予期せぬエラーが発生しました。管理者にお問い合わせください。");
    }
  },
  computed: {
    /**
     * どれかエラーがあればdisabled
     */
    submitDisabled(): boolean {
      return !passwordRegExp.test(this.accountData.newPassword);
    },
  },
  methods: {
    async onClickSubmit() {
      try {
      await passwordResetting({
        id: this.$route.params.id.toString(),
        newPassword: this.accountData.newPassword,
      });
    } catch (e) {
      if (axios.isAxiosError(e) && e.response) {
            var resError = e.response.data as ErrorResponse;
            if (resError.message != null) {
              this.$emit('errorToast', resError.message);
            }
        }
      return;
    }
      this.submitModal = true;
    },
    onPushPath(path: string) {
      this.$router.push(path, () => {}); // eslint-disable-line
      this.$emit("pushPath", path);
    },
  },
});
